import { Component } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { ItemPage } from '../item/page';
import { LocationPage } from '../location/page';
import { ConditionPage } from '../condition/page';
import { ClassificationPage } from '../classification/page';
import { AssetPage } from '../asset/page';
import { FormItemPage } from '../form_item/page';
import { ScanCodePage } from '../scan_code/page';
import { PrintCodePage } from '../print_code/page';
import { TrackingPage } from '../tracking/page';
import { ReportPage } from '../report/page';
import { ProfilePage } from '../profile/page';
import { ReviewPage } from '../reviews/page';
import { LoginPage } from '../login/page';
import { User, Assignment } from '@providers/asset/index';
import { AssignmentPage, LsAssignmentPage } from '../';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  //code:any = {format:'', cancelled:'', text:''};
  menu = [
    {
      text : 'Location',
      go_to: 'location'
    },
    {
      text : 'Classification',
      go_to: 'classification'
    },
    {
      text : 'Condition',
      go_to: 'condition'
    }
  ];
  akses:any={};
  user_data:any={};
  ls_assignment = 0;

  constructor(
    public navCtrl       : NavController,
    public barcodeScanner: BarcodeScanner,
    public alertCtrl     : AlertController,
    public userApi       : User,
    public assignmentApi : Assignment
  ) {
    this.akses = this.userApi.akses;
    this.user_data = JSON.parse(localStorage.data_user);

    this.cekLsAssignment();
  }

  scan(){
    this.barcodeScanner.scan().then(barcodeData => {
      console.log('Barcode data', barcodeData);
      
      
     }).catch(err => {
         console.log('Error', err);
     });
  }

  goto_page(go_to,params={}){
    let    tujuan            = [];
    tujuan['location']       = LocationPage;
    tujuan['classification'] = ClassificationPage;
    tujuan['condition']      = ConditionPage;
    tujuan['asset']          = AssetPage;
    tujuan['form_item']      = FormItemPage;
    tujuan['scan_code']      = ScanCodePage;
    tujuan['print_code']     = PrintCodePage;
    tujuan['list_item']      = ItemPage;
    tujuan['tracking']       = TrackingPage;
    tujuan['profile']        = ProfilePage;
    tujuan['report']         = ReportPage;
    tujuan['review']         = ReviewPage;
    tujuan['assignment']     = AssignmentPage;
    tujuan['ls_assignment']  = LsAssignmentPage;
    if(go_to=='review'){
      params= {review:1};
    }
    this.navCtrl.push(tujuan[go_to],params);
  }

  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: 'Yakin akan keluar ?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {

          }
        },
        {
          text: 'Ya',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    confirm.present();
  }

  cekLsAssignment(){
    let params = { assignee_id: this.user_data.data.employee_id};
    this.assignmentApi.get(params).subscribe((resp:any) => {
        this.ls_assignment = resp.count;
        console.log(resp);
    });
  }

  logout(){
    localStorage.clear();
    this.navCtrl.push(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/home/home.ts